export const HOME = 'home';
export const DASHBOARD = 'dashboard';
export const FLIGHTLIST = 'flightlist';
export const PREMMEALLIST = 'premmeallist';
export const SIGN_IN = 'login';

/* Audit Log */
export const AUDITLOG = 'audit';

/* CABIN CAST */
export const CABINCAST = 'cabincast';
export const CABINCAST_AUDIOFILES = 'audiofiles';
export const CABINCAST_PLAYLISTS = 'playlists';

/* Delay Communication */
export const DELAYCOMM = 'delaycomm';

/* User Feedback */
export const USERFEEDBACK = 'userfeedback';

/* Administration */
export const ADMIN = 'admin';
export const AIRPORTS = 'airports';